module.exports = __webpack_public_path__ + "static/media/2020.8.7未成年人心理辅导讲座.3f5748e3.jpg";